import { createAction } from '@reduxjs/toolkit'
import reducer from './reducer'

export const {
  saveFiltersAndSorter,
  fetchArcAdvertisersSuccess,
  fetchArcAdvertisersFailure,
  fetchArcAdvertiserDetailsSuccess,
  fetchArcAdvertiserDetailsFailure,
  startSaving,
  finishSaving,
  clearData,
} = reducer.actions

export const fetchArcAdvertisers = createAction('arcAdvertisers/fetchArcAdvertisers')
export const fetchArcAdvertiserDetails = createAction('arcAdvertisers/fetchArcAdvertiserDetails')
export const createArcAdvertiser = createAction('arcAdvertisers/createArcAdvertiser')
export const updateArcAdvertiser = createAction('arcAdvertisers/updateArcAdvertiser')
export const deleteArcAdvertiser = createAction('arcAdvertisers/deleteArcAdvertiser')